/**
 * 页脚底部链接：按 link.type 绑定已启用的 CMS 菜单
 */
import { findMenuPathByUtilityType } from '@/components/portal/common/utils/portalRouteResolver'

export const FOOTER_LINK_TYPE_MAP = {
  CONTACT: 'contact',
  LEGAL: 'legal',
  PRIVACY: 'privacy'
}

export const FIXED_FOOTER_LINK_URLS = {
  LEGAL: '/legal',
  PRIVACY: '/privacy'
}

const LEGAL_PAGE_API_KEYS = {
  legal: 'legal',
  privacy: 'privacy'
}

function toFooterType(type) {
  return String(type || '').trim().toUpperCase()
}

function toUtilityType(type) {
  return FOOTER_LINK_TYPE_MAP[toFooterType(type)] || ''
}

export function isKnownFooterLinkType(type) {
  return Boolean(toUtilityType(type))
}

export function hasEnabledFooterLinkMenu(type, menus = [], locale) {
  const utilityType = toUtilityType(type)
  if (!utilityType) return false
  return Boolean(findMenuPathByUtilityType(menus, utilityType, locale))
}

/** 展示用：没有已启用的对应栏目则空；法律/隐私为固定地址 */
export function resolveFooterLinkUrl(type, menus = [], locale) {
  if (!hasEnabledFooterLinkMenu(type, menus, locale)) return ''
  const footerType = toFooterType(type)
  if (FIXED_FOOTER_LINK_URLS[footerType]) return FIXED_FOOTER_LINK_URLS[footerType]
  return findMenuPathByUtilityType(menus, toUtilityType(footerType), locale) || ''
}

/** 按页脚链接类型取实际跳转地址（不读手填 url） */
export function resolveFooterLinkUrlByType(type, links = [], menus = [], locale) {
  const footerType = toFooterType(type)
  const link = (links || []).find(
    (item) => toFooterType(item?.type) === footerType
  )
  if (!link) return ''
  return resolveFooterBottomLink(link, menus, locale).url
}

/** 法律/隐私正文 API key：固定为 legal / privacy */
export function resolveLegalPageApiKey(contentVariant) {
  return LEGAL_PAGE_API_KEYS[contentVariant] || ''
}

/** 解析单条页脚链接的实际跳转地址 */
export function resolveFooterBottomLink(link, menus = [], locale) {
  return {
    type: link?.type || '',
    label: String(link?.label || '').trim(),
    url: resolveFooterLinkUrl(link?.type, menus, locale)
  }
}

/** 解析页脚底部链接列表（仅保留有文案、且已启用对应菜单的项） */
export function resolveFooterBottomLinks(links = [], menus = [], locale) {
  return links
    .map((link) => resolveFooterBottomLink(link, menus, locale))
    .filter((link) => link.label && link.url)
}
